// extracted by mini-css-extract-plugin
export default {"imageSetting":"src-pages-SalesChannelContentEditor-Components-ImageWidthTitle-css__imageSetting--u6ftO"};